import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { ServicePackageFragmentFragmentDoc } from '../fragments/servicePackage.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CopyServicePackageToCurrencyMutationVariables = Types.Exact<{
  input: Types.CopyServicePackageToCurrencyInput;
}>;


export type CopyServicePackageToCurrencyMutation = { __typename?: 'Mutation', copyServicePackageToCurrency: { __typename?: 'CopyServicePackageToCurrencyResult', package: { __typename?: 'ServicePackage', id: string, package_type: Types.ServicePackageType, currency: string, created_at: string, revisions: Array<{ __typename?: 'ServicePackageRevision', id: string, revision_number: number, min_contract_term_months: number, monthly_service_fee_in_cents: number, onboarding_fee_in_cents: number, ops_order_price_in_cents: number, note?: string | null, created_at: string, created_by?: string | null, allowances: Array<{ __typename?: 'ServicePackageAssetAllowance', id: string, monthly_quantity: number, item: { __typename?: 'ItemType', id: number, name: string } }>, free_checkouts: Array<{ __typename?: 'ServicePackageFreeCheckout', id: string, segment: Types.ContainerTypeSegment, amount: number }> }> } } };


export const CopyServicePackageToCurrencyDocument = gql`
    mutation copyServicePackageToCurrency($input: CopyServicePackageToCurrencyInput!) {
  copyServicePackageToCurrency(input: $input) {
    package {
      ...ServicePackageFragment
    }
  }
}
    ${ServicePackageFragmentFragmentDoc}`;
export type CopyServicePackageToCurrencyMutationFn = Apollo.MutationFunction<CopyServicePackageToCurrencyMutation, CopyServicePackageToCurrencyMutationVariables>;

/**
 * __useCopyServicePackageToCurrencyMutation__
 *
 * To run a mutation, you first call `useCopyServicePackageToCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyServicePackageToCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyServicePackageToCurrencyMutation, { data, loading, error }] = useCopyServicePackageToCurrencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyServicePackageToCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<CopyServicePackageToCurrencyMutation, CopyServicePackageToCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyServicePackageToCurrencyMutation, CopyServicePackageToCurrencyMutationVariables>(CopyServicePackageToCurrencyDocument, options);
      }
export type CopyServicePackageToCurrencyMutationHookResult = ReturnType<typeof useCopyServicePackageToCurrencyMutation>;
export type CopyServicePackageToCurrencyMutationResult = Apollo.MutationResult<CopyServicePackageToCurrencyMutation>;
export type CopyServicePackageToCurrencyMutationOptions = Apollo.BaseMutationOptions<CopyServicePackageToCurrencyMutation, CopyServicePackageToCurrencyMutationVariables>;